import React, { useEffect, useState } from 'react';
import JourneyDatePicker from 'src/common/form/JourneyDatePicker';
import { ToggleComponent } from 'src/common/form/toggle/component';
import { ShareLinkFieldType } from '../link-config-form.factory';

interface Props {
  date: ShareLinkFieldType<string>;
  onFieldChange: <T>(payload: ShareLinkFieldType<T>) => void;
  disabled?: boolean;
}

export const ShareExpirationDatePicker = ({ date, onFieldChange, disabled = false }: Props) => {
  const [isExpirationDateEnabled, setIsExpirationDateEnabled] = useState(!!date.value);

  const onDateToggleChanged = () => {
    setIsExpirationDateEnabled(!isExpirationDateEnabled);
  };

  const onDateChanged = (value: any) => {
    onFieldChange({ field: date.field, value });
  };

  useEffect(() => {
    if (!isExpirationDateEnabled && date.value !== '') {
      onFieldChange({ field: date.field, value: '' });
    }
  }, [isExpirationDateEnabled, onFieldChange, date]);

  return (
    <div className='flex flex-col space-y-4 py-6'>
      <ToggleComponent
        checked={isExpirationDateEnabled}
        onChange={onDateToggleChanged}
        label='Expiration date'
        labelType='strong'
        disabled={disabled}
      />
      {isExpirationDateEnabled && (
        <div className='bedrock-datepicker'>
          <JourneyDatePicker currentDate={date.value} customInput={null} onChange={onDateChanged} placeholderText='Pick a date' disabled={disabled} />
        </div>
      )}
    </div>
  );
};
